/*
  # Fixed admin routing system
  
  1. Changes
    - Updated router configuration to properly handle admin routes
    - Fixed routing structure for better navigation
    - Ensured all admin routes are properly configured
*/

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import App from './App.tsx';
import Login from './pages/admin/Login.tsx';
import Dashboard from './pages/admin/Dashboard.tsx';
import Tours from './pages/admin/Tours.tsx';
import CreateTour from './pages/admin/CreateTour.tsx';
import BookingPage from './pages/BookingPage.tsx';
import TourDetail from './pages/TourDetail.tsx';
import EditTour from './pages/admin/EditTour.tsx';
import Items from './pages/admin/Items.tsx';
import TermsAndConditions from './pages/TermsAndConditions.tsx';
import PrivacyPolicy from './pages/PrivacyPolicy.tsx';
import Article from './pages/Article.tsx';
import Gallery from './pages/admin/Gallery.tsx';
import AboutUs from './pages/AboutUs.tsx';
import NotFound from './pages/NotFound.tsx';
import Hero from './pages/admin/Hero.tsx';
import ScientificWork from './pages/ScientificWork.tsx';
import AdminScientificWork from './pages/admin/ScientificWork.tsx';
import AdminNews from './pages/admin/News.tsx';
import AdminBookings from './pages/admin/Bookings.tsx';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}
    >
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/tours/:slug" element={<TourDetail />} />
        <Route path="/tours/:slug/book" element={<BookingPage />} />
        <Route path="/kh-admin/login" element={<Login />} />
        <Route path="/kh-admin" element={<Dashboard />} />
        <Route path="/kh-admin/tours" element={<Tours />} />
        <Route path="/kh-admin/tours/new" element={<CreateTour />} />
        <Route path="/kh-admin/tours/:id/edit" element={<EditTour />} />
        <Route path="/kh-admin/bookings" element={<AdminBookings />} />
        <Route path="/kh-admin/gallery" element={<Gallery />} />
        <Route path="/kh-admin/items" element={<Items />} />
        <Route path="/kh-admin/hero" element={<Hero />} />
        <Route path="/kh-admin/scientific-work" element={<AdminScientificWork />} />
        <Route path="/kh-admin/news" element={<AdminNews />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/scientific-work" element={<ScientificWork />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/terms" element={<Navigate to="/terms-and-conditions" replace />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/privacy" element={<Navigate to="/privacy-policy" replace />} />
        <Route path="/article/:slug" element={<Article />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  </StrictMode>
);